import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Button from '@components/common/Button';
import LeftNavBar from '@pages/AppWrapperViewComponent/LeftNavBar';
import BadgesComponent from '@components/common/Badges';
import BreadcrumbComponent from '@components/common/Breadcrumb';
import { beneficiaryData } from '@constants/index';
import NationalEmblem from './../../../assets/svg_main/national_emblem.svg';
import BackArrowsvg from './../../../assets/svg_main/BackArrowIconSvg.svg';
import { RootState } from '@store/reducers';
import { useDispatch, useSelector } from 'react-redux';
import profilePic from '../../../assets/png/default_profile.png';
import './createBeneficiary.css'
import { getData, postDataJSON, getDataWithCache } from '../../../services/CommonApiService';
import { CommonHamburgar } from '@components/common/CommonHamburgar';
import WomanIcon from "../../../assets/svg_main/Woman.svg";
import ManIcon from "../../../assets/svg_main/Man.svg";
import CommonFormFields from '@pages/Forms/CommonFormFields';
import endpoints from '@config/endpoints';
import CustomTooltip from '@components/common/CustomTooltip';
import InfoBar from '@components/common/InfoBars';
import dayjs from 'dayjs';
import axios from '../../../utils/axiosExt';
import Auth from "../../../utils/auth";
import { Buffer } from 'buffer'

import { updateForm } from '@store/actions/userManagementAction';
import { toast } from 'react-toastify';
import { setAadhar, setAbhaAddress, setBeneficiaryAbha, setBeneficiaryAuthType, setBeneficiaryData, setBeneficiaryMobileNumber, setBeneficiaryRedgOption, setTsnID, setTxnIdForAbhaAddress } from '@store/actions/beneficiaryAction';
import convertByteToImageURL from '@utils/convertByteToImageURL';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '@utils/base64Utils';
import { errorLogger } from '@utils/applicationLogUtils';
import { benef_const } from '@constants/beneficiaryConstant';
import { diffBetweenTwoDays } from '@utils/commonUtils';
interface objectTypes {
    isError: boolean,
    message: string,
    isDisable: boolean,
    value: any,
    id?: any,
    verifiedDetails?: any
    code?: any,
    compositeId?: any
}

interface objectType {
    user: any;
    flow: string;
    handleChange: (e: any, key: string) => void;
}
interface ChildProps {
    page: string,
    flow: string;
}
interface formStateType {
    [key: string]: objectTypes
}
const CreateBeneficiary = (props: ChildProps) => {
    const navigate = useNavigate();
    const inputRef = useRef<any>(null);
    const [imageUrl, setImageUrl] = useState<string>('');
    const [imageError, setImageError] = useState('');
    const [facilityDetails, setFacilityDetails] = useState<any>([]);
    const [aadharImageUrl, setAadharImageUrl] = useState<string>('');
    const [loginId, setLoginId] = useState<string>('');
    const [regId, setRegId] = useState<string>('');
    const [genderId, setGenderId] = useState<string>('');
    const [facilityId, setFacilityId] = useState<string>('')
    const [userType, setUserType] = useState<string>('')
    const [userName, setUserName] = useState<string>('')
    const beneficiary = useSelector((state: RootState) => state.beneficiary);
    const abhaAddressFromStore  = useSelector((state: RootState) => state.beneficiary.abhaAddress);
    const [urbanRural, setUrbanRural] = useState<string>('');
    const Files = useSelector((state: RootState) => state.user.file);
    const [beneficiaryForm, setBeneficiaryForm] = useState<formStateType>({
        abhaId: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        abhaAddress: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        name: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        gender: {
            isError: false,
            message: '',
            id: '',
            isDisable: false,
            value: '',
        },
        dob: {
            isError: false,
            message: '',
            id: '',
            isDisable: false,
            value: '',

        },
        primaryMob: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        address: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        sName: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        caste: {
            isError: false,
            message: '',
            isDisable: false,
            value: null,
        },
        aNumber: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        ward: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        village: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        healthProviderName: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },

        mobiliserName: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        facilityType: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        facilityName: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        sms: {
            isError: false,
            message: '',
            isDisable: true,
            value: false,
        },
        pvtg: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        Religion: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        other_religion: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        }
    })
    const [beneficiaryFormData, setBeneficiaryFormData] = useState<any>(beneficiaryData);
    const dispatch = useDispatch();
    const data = useSelector((state: RootState) => state.beneficiary.beneficiaryData);
    const [ufId, setUfId] = useState<string>('');
    const userDetail = JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userDetails')));

    const userId = localStorage.getItem('userId');
    const [uploadMethod, setUploadMethod] = useState<'local' | 'url' | null>(
        null,
    );
    const isValueContainsOnlyDigits = (value: any) => {
        return /^\d*$/.test(value);
    };
    const handleChange = async (value: any | boolean, key: string, option?: any, id?: any, code?: any) => {
        if (value && key === 'facilityName') {
            const facilityDetail = facilityDetails?.find((item: any) => item.facility_name === value);

            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                facilityType: {
                    ...prevState.facilityType,
                    value: facilityDetail.facility_type_name,
                    isError: false,
                    message: '',
                    id: facilityDetail.facility_type_id,
                },
                mobiliserName: {
                    ...prevState.mobiliserName,
                    value: '',
                    id: ''
                },
                ward: {
                    ...prevState.ward,
                    value: '',
                    id: ''
                },
                village: {
                    ...prevState.village,
                    value: '',
                    id: ''
                },
                healthProviderName: {
                    ...prevState.healthProviderName,
                    value: '',
                    id: ''
                }
            }));
            setBeneficiaryFormData((beneficiary_facilitydetails: { healthProviderName: any, mobiliserName: any, facilityName: any; ward: any; village: any }) => ({
                ...beneficiary_facilitydetails,
                healthProviderName: {
                    ...beneficiary_facilitydetails.healthProviderName,
                    '#options': []
                },
                ward: {
                    ...beneficiary_facilitydetails.ward,
                    '#options': []
                },
                village: {
                    ...beneficiary_facilitydetails.village,
                    '#options': []
                },
                mobiliserName: {
                    ...beneficiary_facilitydetails.mobiliserName,
                    '#options': []
                }
            }));

        } else if (!value && key === 'facilityName') {
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                mobiliserName: {
                    ...prevState.mobiliserName,
                    value: '',
                    id: ''
                },
                healthProviderName: {
                    ...prevState.healthProviderName,
                    value: '',
                    id: ''
                },
                ward: {
                    ...prevState.ward,
                    value: '',
                    id: ''
                },
                village: {
                    ...prevState.village,
                    value: '',
                    id: ''
                },
                facilityType: {
                    ...prevState.facilityType,
                    value: '',
                    id: ''
                },

            }));
            setBeneficiaryFormData((beneficiary_facilitydetails: { healthProviderName: any, mobiliserName: any, facilityName: any; ward: any; village: any }) => ({
                ...beneficiary_facilitydetails,
                facilityName: {
                    ...beneficiary_facilitydetails.facilityName,
                    '#options': facilityDetails?.map((key: any) => ({
                        value: key.facility_name,
                        label: key.facility_name,
                        id: key.facility_id
                    }))
                },
                healthProviderName: {
                    ...beneficiary_facilitydetails.healthProviderName,
                    '#options': []
                },
                ward: {
                    ...beneficiary_facilitydetails.ward,
                    '#options': []
                },
                village: {
                    ...beneficiary_facilitydetails.village,
                    '#options': []
                },
                mobiliserName: {
                    ...beneficiary_facilitydetails.mobiliserName,
                    '#options': []
                }
            }));
        } else if (!value && key === 'facilityType') {
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                mobiliserName: {
                    ...prevState.mobiliserName,
                    value: '',
                    id: ''
                },
                healthProviderName: {
                    ...prevState.healthProviderName,
                    value: '',
                    id: ''
                },
                ward: {
                    ...prevState.ward,
                    value: '',
                    id: ''
                },
                village: {
                    ...prevState.village,
                    value: '',
                    id: ''
                },
                facilityName: {
                    ...prevState.facilityName,
                    value: '',
                    id: ''
                },

            }));
            let facility_name_options = facilityDetails?.map((key: any) => ({
                value: key.facility_name,
                label: key.facility_name,
                id: key.facility_id
            }))
            facility_name_options = facility_name_options?.filter((key: { value: any; }) => key.value)


            setBeneficiaryFormData((beneficiary_facilitydetails: { healthProviderName: any, mobiliserName: any, facilityName: any; ward: any; village: any }) => ({
                ...beneficiary_facilitydetails,
                facilityName: {
                    ...beneficiary_facilitydetails.facilityName,
                    '#options': facility_name_options,
                },
                healthProviderName: {
                    ...beneficiary_facilitydetails.healthProviderName,
                    '#options': []
                },
                ward: {
                    ...beneficiary_facilitydetails.ward,
                    '#options': []
                },
                village: {
                    ...beneficiary_facilitydetails.village,
                    '#options': []
                },
                mobiliserName: {
                    ...beneficiary_facilitydetails.mobiliserName,
                    '#options': []
                }
            }));
        } else if (value && key === 'facilityType') {
            const filteredFacilityDetails: any[] = facilityDetails?.filter((item: any) => item.facility_type_name === value && item.facility_name) || [];
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                mobiliserName: {
                    ...prevState.mobiliserName,
                    value: '',
                    id: ''
                },
                healthProviderName: {
                    ...prevState.healthProviderName,
                    value: '',
                    id: ''
                },
                ward: {
                    ...prevState.ward,
                    value: '',
                    id: ''
                },
                village: {
                    ...prevState.village,
                    value: '',
                    id: ''
                },
                facilityName: {
                    ...prevState.facilityName,
                    value: '',
                    id: ''
                },
            }));
            const facility_name_options = filteredFacilityDetails.map((key: any) => ({
                value: key.facility_name,
                label: key.facility_name,
                id: key.facility_id
            }))

            setBeneficiaryFormData((beneficiary_facilitydetails: { healthProviderName: any, mobiliserName: any, facilityName: any; ward: any; village: any }) => ({
                ...beneficiary_facilitydetails,
                facilityName: {
                    ...beneficiary_facilitydetails.facilityName,
                    '#options': facility_name_options,
                },
                healthProviderName: {
                    ...beneficiary_facilitydetails.healthProviderName,
                    '#options': []
                },
                ward: {
                    ...beneficiary_facilitydetails.ward,
                    '#options': []
                },
                village: {
                    ...beneficiary_facilitydetails.village,
                    '#options': []
                },
                mobiliserName: {
                    ...beneficiary_facilitydetails.mobiliserName,
                    '#options': []
                }
            }));
        }
        else if (value && key === 'healthProviderName') {
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                mobiliserName: {
                    ...prevState.mobiliserName,
                    value: '',
                    id: '',
                    isError: false,
                    message: '',
                }
            }));
            const ufTaggedId = id.find((item: any) => item.id === option);
            setUfId(ufTaggedId.ufTaggedId)
        }
        else if (!value && key === 'healthProviderName') {
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                mobiliserName: {
                    ...prevState.mobiliserName,
                    value: '',
                    id: '',
                    isError: false,
                    message: '',
                }
            }));
        }
        if ((key === "primaryMob" || key === 'aNumber') && (!isValueContainsOnlyDigits(value) || value.length > 10)) {
            return
        }
        setBeneficiaryForm((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                value: value,
                isError: false,
                message: '',
                id: option,
                code: code
            },
        }))
    }
    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files && event.target.files[0];
        setImageError('');
        if (selectedFile) {
            const fileType = selectedFile.type;
            const fileSize = selectedFile.size;
            if (fileSize > 1048576) {
                setImageError('File size must be less than or equal to 1MB');
                return;
            }
            if (!['image/jpeg', 'image/png', 'image/jpg'].includes(fileType)) {
                setImageError('Only JPG, JPEG and PNG images are allowed');
                return;
            }
            setImageUrl(URL.createObjectURL(selectedFile));
            setUploadMethod(null);
            const file = selectedFile;
            const formData = new FormData()
            formData.append('file', selectedFile);
            dispatch(updateForm("file", formData));

        }
    };
    useEffect(() => {
        setBeneficiaryForm((userFormState: any) => ({
            ...userFormState,
            name: {
                ...userFormState.name,
                value: data[0]?.name,
            },
            gender: {
                ...userFormState.gender,
                value: data[0]?.gender === 'F' ? "Female" : data[0]?.gender === "Female" ? "Female" : "Male",
            },
            abhaId: {
                ...userFormState.abhaId,
                value: data[0]?.abhaId?.replace("-", "")?.replace("-", ""),
            },
            primaryMob: {
                ...userFormState.primaryMob,
                value: data[0]?.mob ? data[0]?.mob : data[0]?.mobile
            },
            dob: {
                ...userFormState.dob,
                value: data[0].dob? dayjs(data[0]?.dob?.split('-')?.reverse()?.join('-')) : dayjs(data[0]?.dateOfBirth?.split('-')?.reverse()?.join('-')),
            },
            address: {
                ...userFormState.address,
                value: data[0]?.address,
            },
            profile:{
                ...userFormState.profile,
                value: data[0]?.profile,
            }

        }));
        if(!data[0]?.isAlreadyExist?.includes('already exist') && beneficiary?.beneficiaryRedgeOption === 'Aadhaar' && beneficiary?.beneficiaryAuthType === 'OTP'){
            const [abhaAddressPart, suffixPart] = (data[0]?.address ?? '').split('@');
            const suffix = '@' + suffixPart;
            setBeneficiaryFormData((prevState: any) => ({
                ...prevState,
                ['abhaAddress']: {
                    ...prevState['abhaAddress'],
                    '#isVisible':true,
                    '#isDisabled': true,
                    '#isBtnDisabled': false,
                    '#suffix' : suffix,
                },
            }));
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                ['abhaAddress']: {
                    ...prevState['abhaAddress'],
                    value: abhaAddressPart,
                },
            }));
        }
        else {
            setBeneficiaryFormData((prevState: any) => {
                return {
                    ...prevState,
                    ['abhaAddress']: {
                        ...prevState['abhaAddress'],
                        '#type':'textfield',
                        '#isDisabled': true,
                        // '#isBtnDisabled': true,
                        '#isVisible':true,
                    },
                }
            });
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                ['abhaAddress']: {
                    ...prevState['abhaAddress'],
                    value: data[0]?.address,
                },
            }));
        }
        const fetchData = async () => {
            setUrbanRural(userDetail.urban_rural_name);
            setUserType(userDetail.usertype_name);
            setUserName(userDetail.first_name + ' ' + userDetail.middle_name + ' ' + userDetail.last_name);
            if(userDetail.user_designation_name === "ANM"){
                setBeneficiaryFormData((prevState: any) => {
                    return {
                        ...prevState,
                        ['healthProviderName']:{
                            ...prevState['healthProviderName'],
                            '#isDisabled': true,
                        },
                    }
                })
            }
            
            if (userDetail.urban_rural_name === 'urban') {
                setBeneficiaryFormData((prevState: any) => {
                    return {
                        ...prevState,
                        ['ward']: {
                            ...prevState['ward'],
                            '#options': []
                        },
                        ['village']: {
                            ...prevState['village'],
                            '#isDisabled': true,
                        },
                    }
                })
            }
            else {
                setBeneficiaryFormData((prevState: any) => {
                    return {
                        ...prevState,
                        ['ward']: {
                            ...prevState['ward'],
                            '#isDisabled': true,
                        },
                        ['village']: {
                            ...prevState['village'],
                            '#options': [],
                        }
                    }
                })
            }
            const staticBenfCreateDetails=await getDataWithCache<any>(`${endpoints.getStaticBenfCreateDetails}`);
            setBeneficiaryFormData((prevState: any) => {
                return {
                    ...prevState,
                    ['caste']: {
                        ...prevState['caste'],
                        '#options': staticBenfCreateDetails?.data.categoryData.map((key: any) => ({
                            value: key.category_name,
                            label: key.category_name,
                            id: key.category_id,
                            code: key.category_code
                        }))
                    }
                }
            })
            const religion = staticBenfCreateDetails?.data.religionData[0].map((key: any) => ({
                value: key.religion_name,
                label: key.religion_name,
                id: key.religion_id,
                code: key.religion_code
            }));
            setBeneficiaryFormData((prevState: any) => {
                return {
                    ...prevState,
                    ['Religion']: {
                        ...prevState['Religion'],
                        '#options': religion
                    }
                }
            })
            const facility_details_response = await getData<any>(`${endpoints.getLinkedFacilitiesByUserById}/${userId}`);
            setFacilityDetails(facility_details_response.data[0]);
            const parentFacility = facility_details_response.data[0]?.find((item: any) => item.is_parent === true);
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                ['facilityName']: {
                    ...prevState['facilityName'],
                    value: parentFacility?.facility_name,
                    id: parentFacility?.facility_id
                },
                ['facilityType']: {
                    ...prevState['facilityType'],
                    value: parentFacility?.facility_type_name,
                    id: parentFacility?.facility_type_id
                }
            }))
            setBeneficiaryFormData((beneficiary_facilitydetails: { facilityName: any }) => ({
                ...beneficiary_facilitydetails,
                ['facilityName']: {
                    ...beneficiary_facilitydetails['facilityName'],
                    '#options': facility_details_response.data[0]?.map((key: any) => ({
                        value: key.facility_name,
                        label: key.facility_name,
                        id: key.facility_id
                    }))
                }
            }));
            if (facility_details_response.data[0]?.length === 1) {
                setBeneficiaryForm((prevState: any) => ({
                    ...prevState,
                    ['facilityName']: {
                        ...prevState['facilityName'],
                        value: facility_details_response.data[0][0]?.facility_name,
                        id: facility_details_response.data[0][0]?.facility_id
                    },
                    ['facilityType']: {
                        ...prevState['facilityType'],
                        value: facility_details_response.data[0][0]?.facility_type_name,
                        id: facility_details_response.data[0][0]?.facility_type_id
                    }

                }))
                setBeneficiaryFormData((beneficiary_facilitydetails: { facilityName: any,facilityType:any }) => ({
                    ...beneficiary_facilitydetails,
                    ['facilityName']: {
                        ...beneficiary_facilitydetails['facilityName'],
                        '#isDisabled': true,
                    },
                    ['facilityType']: {
                        ...beneficiary_facilitydetails['facilityType'],
                        '#isDisabled': true,
                    }
                }));
            }
            if (userDetail.user_designation_name === "ANM" && facility_details_response.data[0]?.length > 1) {
                setBeneficiaryFormData((prevState: any) => ({
                    ...prevState,
                    ['facilityType']: {
                        ...prevState['facilityType'],
                        '#isDisabled': false,
                    },
                    ['facilityName']: {
                        ...prevState['facilityName'],
                        '#isDisabled': false,
                    },
                }));
            }
            if(userDetail.usertype_name=== 'Field Level User'){
                setBeneficiaryFormData((beneficiary_facilitydetails: { mobiliserName: any }) => ({
                    ...beneficiary_facilitydetails,
                    ['mobiliserName']: {
                        ...beneficiary_facilitydetails['mobiliserName'],
                        '#isDisabled': true,
                    }
                }));
                const healthProviderLinked= await getDataWithCache<any>(`${endpoints.getHealthProviderByAsha}/${userId}/${userDetail.facility_id}`);
                setBeneficiaryForm((prevState: any) => ({
        ...prevState,
        ['healthProviderName']: {
        ...prevState['healthProviderName'],
        value: healthProviderLinked?.data[0][0]?.f_name + ' ' + healthProviderLinked?.data[0][0]?.l_name,
        id: healthProviderLinked?.data[0][0]?.get_healthprovider_id
        }
    }))
    const ashaFullName = [userDetail.first_name, userDetail.middle_name, userDetail.last_name]
        .filter(Boolean)
        .join(' ');
    setBeneficiaryForm((prevState: any) => ({
        ...prevState,
        ['mobiliserName']: {
          ...prevState['mobiliserName'],
          value: ashaFullName,
          id:userId
        },
      }));
    setBeneficiaryFormData((beneficiary_facilitydetails: { mobiliserName: any,healthProviderName:any }) => ({
        ...beneficiary_facilitydetails,
        ['mobiliserName']: {
            ...beneficiary_facilitydetails['mobiliserName'],
            '#isDisabled': true,
        },
        ['healthProviderName']:{
            ...beneficiary_facilitydetails['healthProviderName'],
            '#isDisabled': true,
        }
                }));
            }
            const facilityTypes = facility_details_response?.data[0]?.map((key: any) => ({
                value: key.facility_type_name,
                label: key.facility_type_name,
                id: key.facility_type_id
            }));
            const filteredFacilityType = facilityTypes.filter((obj: any, index: any) => {
                return index === facilityTypes.findIndex((o: any) => obj.value === o.value);
            })
            setBeneficiaryFormData((prevState: any) => {
                return {
                    ...prevState,
                    ['facilityType']: {
                        ...prevState['facilityType'],
                        '#options': filteredFacilityType

                    }
                }
            })
            if (beneficiary.beneficiaryGender === "Female" || beneficiary.beneficiaryGender === "F") {
                setGenderId(staticBenfCreateDetails.data.genderData?.find((g: any) => g.gender_code === '1002')?.gender_id)
            }
            else {
                setGenderId(staticBenfCreateDetails.data.genderData?.find((g: any) => g.gender_code === '1001')?.gender_id)
            }
            if (beneficiary.beneficiaryAuthType === 'Demographics') {
                setRegId(staticBenfCreateDetails.data.registrationProcessData[1].reg_process_id)
            }
            else if (beneficiary.beneficiaryAuthType === "OTP") {
                setRegId(staticBenfCreateDetails.data.registrationProcessData[0].reg_process_id)
            }
            else if (beneficiary.beneficiaryAuthType === "Face_Auth_Creation") {
                setRegId(staticBenfCreateDetails.data.registrationProcessData[3].reg_process_id)
            }
            else if (beneficiary.beneficiaryRedgeOption === 'Phone_Number') {
                setRegId(staticBenfCreateDetails.data.registrationProcessData[0].reg_process_id)
            }
            else if (beneficiary.beneficiaryRedgeOption === 'Face_Authentication') {
                setRegId(staticBenfCreateDetails.data.registrationProcessData[3].reg_process_id)
            }
            if (beneficiary.beneficiaryRedgeOption == 'Face_Authentication') {
                setLoginId(staticBenfCreateDetails.data.loginProcessData[4].login_process_id)
            }
            else if (beneficiary.beneficiaryRedgeOption == 'Aadhaar') {
                setLoginId(staticBenfCreateDetails.data.loginProcessData[1].login_process_id)
            }
            else if (beneficiary.beneficiaryRedgeOption == 'ABHA') {
                setLoginId(staticBenfCreateDetails.data.loginProcessData[0].login_process_id)
            }

            if (beneficiary.beneficiaryRedgeOption == 'Phone_Number') {
                setLoginId(staticBenfCreateDetails.data.loginProcessData[2].login_process_id)
            }
            if (beneficiary.beneficiaryRedgeOption == 'Temporary_Registration') {
                setLoginId(staticBenfCreateDetails.data.loginProcessData[3].login_process_id)
            }
            if(data[0]?.profile){
                (data[0]?.profile!=undefined||data[0]?.profile!=null) && setAadharImageUrl(convertByteToImageURL(Buffer.from(data[0]?.profile, 'base64')));
                const response:any =(data[0]?.profile!=undefined||data[0]?.profile!=null) && await fetch(convertByteToImageURL(Buffer.from(data[0]?.profile, 'base64')));
                const blob = (data[0]?.profile!=undefined||data[0]?.profile!=null) && await response?.blob();
                const file = new File([blob], 'aadharImage.png', { type: blob.type });
                const uploadEvent = {
                    target: {
                        files: [file],
                    }
                };
                (data[0]?.profile!=undefined||data[0]?.profile!=null) && await handleFileChange(uploadEvent as unknown as React.ChangeEvent<HTMLInputElement>);
            }
        }
        fetchData();


    }, []);

    useEffect(() => {
        if (abhaAddressFromStore) {
            setBeneficiaryFormData((prevState: any) => ({
                ...prevState,
                ['abhaAddress']: {
                    ...prevState['abhaAddress'],
                    '#type':'textfield',
                    '#isVisible':true,
                    '#isDisabled': true,
                },
            }));
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                ['abhaAddress']: {
                    ...prevState['abhaAddress'],
                    value: abhaAddressFromStore,
                },
            }));
        }

    }, [abhaAddressFromStore])

    useEffect(() => { }, [imageUrl, ufId, aadharImageUrl]);
    useEffect(() => {
        if (beneficiaryForm.caste.value !== 'ST') {
            delete beneficiaryFormData.pvtg
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                ['pvtg']: {
                    ...prevState['pvtg'],
                    value: null,
                    isError: false,
                    message: ''
                },
            }))
        }
        else {
            setBeneficiaryFormData((prevState: any) => {
                return {
                    ...prevState,
                    pvtg: {
                        '#type': 'radioButton',
                        '#title': 'Is PVTG Classified',
                        '#webform_key': 'pvtg',
                        '#required': true,
                        '#isDisabled': false,
                        '#group': 'beneficiaryCreate',
                        '#options': ["Yes", "No"]
                    }
                }
            })
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                ['pvtg']: {
                    ...prevState['pvtg'],
                    value: '',
                    isError: false,
                    message: ''
                },
            }))
        }
    }, [beneficiaryForm.caste.value])
    useEffect(() => {
        if (beneficiaryForm.Religion.value !== 'Others') {
            setBeneficiaryFormData((prevState: any) => {
                return {
                    ...prevState,
                    ['other_religion']: {
                        ...prevState['other_religion'],
                        '#isDisabled': true,
                        '#required': false,
                    }
                }
            })
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                ['other_religion']: {
                    ...prevState['other_religion'],
                    value: '',
                    isError: false,
                    message: ''
                },
            }))
        }
        else {
            setBeneficiaryFormData((prevState: any) => {
                return {
                    ...prevState,
                    ['other_religion']: {
                        ...prevState['other_religion'],
                        '#isDisabled': false,
                        '#required': true,
                    }
                }
            })
            setBeneficiaryForm((prevState: any) => ({
                ...prevState,
                ['other_religion']: {
                    ...prevState['other_religion'],
                    value: '',
                    isError: false,
                    message: ''
                },
            }))
        }
    }, [beneficiaryForm.Religion.value])
    const fetchHealthProviderData = async () => {
        try {
            const facilityIdData = facilityDetails?.find((item: any) => item.facility_name === beneficiaryForm.facilityName.value)?.facility_id;
            setFacilityId(facilityIdData);
            const healthProviderData = await getDataWithCache<any>(`${endpoints.getHealthProviderTagged(facilityIdData)}`);
            setBeneficiaryFormData((prevState: any) => {
                return {
                    ...prevState,
                    ['healthProviderName']: {
                        ...prevState['healthProviderName'],
                        '#options': healthProviderData?.data.map((key: any) => ({
                            value: `${key.f_name} ${key.l_name}`,
                            label: `${key.f_name} ${key.l_name}`,
                            id: key.user_id,
                            code: key.user_code,
                            ufTaggedId: key.uf_tagged_id
                        })),
                    }
                }
            })
            if (userType === 'Facility Level User' || healthProviderData?.data.length === 1) {
                const anmData = healthProviderData?.data.find((item: any) => `${item.f_name} ${item.l_name}` === userName.replace('null', '').replace('  ', ' '));
                if (anmData) {
                    setBeneficiaryForm((prevState: any) => ({
                        ...prevState,
                        ['healthProviderName']: {
                            ...prevState['healthProviderName'],
                            value: anmData?.f_name + ' ' + anmData?.l_name,
                            id: anmData?.user_id
                        }
                    }))
                    const AshaName = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(anmData.uf_tagged_id)}`);
                    const Ashaname = AshaName?.data.map((key: any) => ({
                        value: key.f_name + " " + key.l_name,
                        label: key.f_name + " " + key.l_name,
                        id: key.mobiliser_id,
                        code: key.user_code
                    }));
                    const isAshaFieldDisabled = AshaName?.data?.length > 1;
                    setBeneficiaryFormData((prevState: any) => {
                        return {
                            ...prevState,
                            ['mobiliserName']: {
                                ...prevState['mobiliserName'],
                                '#isDisabled':!isAshaFieldDisabled,
                                '#options': Ashaname,
                            }
                        }
                    })
                    {!isAshaFieldDisabled && setBeneficiaryForm((prevState: any) => ({
                        ...prevState,
                        ['mobiliserName']: {
                            ...prevState['mobiliserName'],
                            value: Ashaname?.[0]?.value,
                            id: Ashaname?.[0]?.id,
                            code: Ashaname?.[0]?.code
                        }
                    }))}
                }
            }
            if(userDetail?.user_designation_name === 'ANM') {
                setBeneficiaryFormData((prevState: any) => {
                  return {
                    ...prevState,
                    ['Health_Provider_Name']: {
                      ...prevState['Health_Provider_Name'],
                      '#isDisabled': true,
                    }
                  }
                })
              }
        }
        catch(error:any){
            errorLogger(error?.response?.data||error?.response||error)
          }
    }
    const fetchAshaData = async () => {
        const mobiliserTaggedData = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(ufId)}`);
        setBeneficiaryForm((prevState: any) => ({
            ...prevState,
            ['mobiliserName']: {
                ...prevState['mobiliserName'],
                value: '',
                id: ''
            }
        }))
        setBeneficiaryFormData((prevState: any) => {
            return {
                ...prevState,
                ['mobiliserName']: {
                    ...prevState['mobiliserName'],
                    '#options': mobiliserTaggedData?.data?.map((key: any) => ({
                        value: key.f_name + " " + key.l_name,
                        label: key.f_name + " " + key.l_name,
                        id: key.mobiliser_id,
                        code: key.user_code
                    }))
                }
            }
        })
    }
    const fetchWardVillageData = async () => {
        const ufIdData = facilityDetails?.find((item: any) => item.facility_name === beneficiaryForm.facilityName.value);
        if (urbanRural === 'urban') {
            const wardData = await getDataWithCache<any>(`${endpoints.getWardByUfId(ufIdData.uf_id)}`);
            const ward_options = wardData?.data[0]?.map((key: any) => ({
                value: key.ward_name + "-" + key.ward_code,
                label: key.ward_name + "-" + key.ward_code,
                id: key.ward_id
            }))
            setBeneficiaryFormData((prevState: any) => {
                return {
                    ...prevState,
                    ['ward']: {
                        ...prevState['ward'],
                        '#options': ward_options
                    },
                    ['village']: {
                        ...prevState['village'],
                        '#isDisabled': true,
                    }
                }
            })
        }
        else {
            const villageData = await getDataWithCache<any>(`${endpoints.getVillageByUfId(ufIdData.uf_id)}`);
            const village_options = villageData?.data[0]?.map((key: any) => ({
                value: key.village_name + "-" + key.village_code,
                label: key.village_name + "-" + key.village_code,
                id: key.village_id
            }))
            setBeneficiaryFormData((prevState: any) => {
                return {
                    ...prevState,
                    ['village']: {
                        ...prevState['village'],
                        '#options': village_options
                    },
                    ['ward']: {
                        ...prevState['ward'],
                        '#isDisabled': true
                    }
                }
            })
        }
    }
    useEffect(() => {
        if (beneficiaryForm.facilityName.value !== '' && beneficiaryForm.facilityName.value !== undefined) {
            fetchHealthProviderData();
            fetchWardVillageData();
        }
    }, [beneficiaryForm.facilityName.value])
    useEffect(() => {
        if (beneficiaryForm.healthProviderName.value !== '' && beneficiaryForm.healthProviderName.value !== undefined &&
            ufId !== '' && ufId !== undefined
        ) {
            fetchAshaData();
        }
    }, [ufId])
    const handleUploadClick = (method: 'local' | 'url') => {
        inputRef.current?.click();
        setUploadMethod(method);
    };

    const handleSubmit = async () => {
        const isError: boolean[] = [];
        const beneficiaryFormStateError = {
            ...beneficiaryForm
        };
        let isBeneficiaryFormError = false;
        Object.keys(beneficiaryFormStateError).map((item) => {
            // if (item === 'address') {
            //     if (!beneficiaryFormStateError.address.value) {
            //         isBeneficiaryFormError = true;
            //         beneficiaryFormStateError.address.isError = true;
            //         beneficiaryFormStateError.address.message = 'Address cannot be kept blank. Enter a valid address';
            //     }
            //     else {
            //         beneficiaryFormStateError.address.isError = false;
            //     }
            // }
            if (item === 'sName') {
                if (!beneficiaryFormStateError.sName.value) {
                    isBeneficiaryFormError = true;
                    beneficiaryFormStateError.sName.isError = true;
                    beneficiaryFormStateError.sName.message = 'Spouse name cannot be kept blank. Enter a valid spouse name.';
                }
                else if (!/^[a-zA-Z\s]+$/.test(beneficiaryFormStateError.sName.value)) {
                    isBeneficiaryFormError = true;
                    beneficiaryFormStateError.sName.isError = true;
                    beneficiaryFormStateError.sName.message = 'Entered spouse name is invalid. Number & Special characters are not allowed.';
                }
                else if (beneficiaryFormStateError.sName.value.length > 100) {
                    isBeneficiaryFormError = true;
                    beneficiaryFormStateError.sName.isError = true;
                    beneficiaryFormStateError.sName.message = 'Entered spouse name length is invalid. Max 100 characters are allowed.';
                }
                else {
                    beneficiaryFormStateError.sName.isError = false;
                }
            }
            if (item === 'abhaAddress' && beneficiaryFormData.abhaAddress["#isVisible"] === true && beneficiaryFormData.abhaAddress["#required"] === true) {
                if (!beneficiaryFormStateError.abhaAddress?.value) {
                    isBeneficiaryFormError = true;
                    beneficiaryFormStateError.abhaAddress.isError = true;
                    beneficiaryFormStateError.abhaAddress.message = 'Abha Address cannot be empty.';
                }
                else {
                    beneficiaryFormStateError.abhaAddress.isError = false;
                }
            }
            if (item === 'facilityType') {
                if (!beneficiaryFormStateError.facilityType.value) {
                    isBeneficiaryFormError = true;
                    beneficiaryFormStateError.facilityType.isError = true;
                    beneficiaryFormStateError.facilityType.message = 'Select Facility Type from the dropdown.';
                }
                else {
                    beneficiaryFormStateError.facilityType.isError = false;
                }
            }
            if (item === 'facilityName') {
                if (!beneficiaryFormStateError.facilityName.value) {
                    isBeneficiaryFormError = true;
                    beneficiaryFormStateError.facilityName.isError = true;
                    beneficiaryFormStateError.facilityName.message = 'Select Facility Name from the dropdown.';
                }
                else {
                    beneficiaryFormStateError.facilityName.isError = false;
                }
            }
            if (item === 'healthProviderName') {
                if (!beneficiaryFormStateError.healthProviderName.value) {
                    isBeneficiaryFormError = true;
                    beneficiaryFormStateError.healthProviderName.isError = true;
                    beneficiaryFormStateError.healthProviderName.message = 'Select Health Provider Name from the dropdown.';
                }
                else {
                    beneficiaryFormStateError.healthProviderName.isError = false;
                }
            }
            if (item === 'pvtg' && beneficiaryFormData.pvtg) {
                if (!beneficiaryFormStateError.pvtg.value) {
                    isBeneficiaryFormError = true;
                    beneficiaryFormStateError.pvtg.isError = true;
                    beneficiaryFormStateError.pvtg.message = 'Is PVTG Classified cannot be empty. Choose either Yes or No.';
                }
                else {
                    beneficiaryFormStateError.pvtg.isError = false;
                }
            }
            if (item === 'aNumber') {
                if (beneficiaryFormStateError.aNumber.value.length !== 0) {
                    if (!/^\d+$/.test(beneficiaryFormStateError.aNumber.value)) {
                        isBeneficiaryFormError = true;
                        beneficiaryFormStateError.aNumber.isError = true;
                        beneficiaryFormStateError.aNumber.message = "Phone Number contains invalid Characters. Enter a Valid Phone Number.";
                    }
                    if (beneficiaryFormStateError.aNumber.value.length !== 10) {
                        isBeneficiaryFormError = true;
                        beneficiaryFormStateError.aNumber.isError = true;
                        beneficiaryFormStateError.aNumber.message = 'Mobile number Must Contain 10 Digits. Enter a valid Mobile number.';
                    }
                }
                else {
                    beneficiaryFormStateError.aNumber.isError = false;
                }
            }
            if (item === 'number') {
                if (beneficiaryFormStateError.number.value.length !== 0) {
                    if (!/^\d+$/.test(beneficiaryFormStateError.number.value)) {
                        isBeneficiaryFormError = true;
                        beneficiaryFormStateError.number.isError = true;
                        beneficiaryFormStateError.number.message = "Phone Number contains invalid Characters. Enter a Valid Phone Number.";
                    }
                    if (beneficiaryFormStateError.number.value.length !== 10) {
                        isBeneficiaryFormError = true;
                        beneficiaryFormStateError.number.isError = true;
                        beneficiaryFormStateError.number.message = 'Mobile number Must Contain 10 Digits. Enter a valid Mobile number.';
                    }
                }
                else {
                    beneficiaryFormStateError.aNumber.isError = false;
                }
            }
            if (item === 'other_religion' && beneficiaryFormData.other_religion["#isDisabled"] === false) {
                if (beneficiaryForm.Religion.value !== 'Others') {
                    beneficiaryFormStateError.other_religion.isError = false;
                }
                if (!beneficiaryFormStateError.other_religion?.value) {
                    isBeneficiaryFormError = true;
                    beneficiaryFormStateError.other_religion.isError = true;
                    beneficiaryFormStateError.other_religion.message = 'Enter the details other religion';
                }
                else {
                    beneficiaryFormStateError.other_religion.isError = false;
                }
            }
            if (item === 'dob') {
                if(diffBetweenTwoDays(beneficiaryForm.dob.value, dayjs(), 'years') < 10) {
                    isBeneficiaryFormError = true;
                    beneficiaryFormStateError.dob.isError = true;
                    beneficiaryFormStateError.dob.message = "Beneficiary should be above 10 years to get registered.";
                }
            }
            setBeneficiaryForm(beneficiaryFormStateError);
            isError[0] = isBeneficiaryFormError;
        })
                
        if (!isBeneficiaryFormError) {
            const abhaAddress = beneficiaryFormData.abhaAddress['#type'] === 'InputFieldWithSuffix' ? `${beneficiaryForm.abhaAddress.value}${beneficiaryFormData.abhaAddress['#suffix']}` : `${beneficiaryForm.abhaAddress.value}`
            const payload = {
                loginProcessId: loginId,
                regProcessId: regId,
                consentTemplateId: beneficiary?.consentLanguageID?  beneficiary?.consentLanguageID.map((item:any) => item.consent_template_id): [],
                genderId: genderId,
                abhaId: data[0]?.abhaId.replace("-", "").replace("-", ""),
                beneficiaryName: data[0]?.name,
                beneficiaryDob: data[0].dob ? data[0].dob.split('-').reverse().join('-') : data[0]?.dateOfBirth?.split('-').reverse().join('-'),
                primaryMob: data[0].mob ? data[0].mob : data[0].mobile,
                abhaAddress: abhaAddress,
                spouseName: beneficiaryForm.sName.value,
                categoryId: beneficiaryForm.caste.id ? beneficiaryForm.caste.id : null,
                religionId: beneficiaryForm?.Religion?.id || null,
                otherReligion: beneficiaryForm?.other_religion?.value || null,
                alternateMob: beneficiaryForm.aNumber.value,
                healthProviderId: beneficiaryForm.healthProviderName.id ? [beneficiaryForm.healthProviderName.id] : [],
                mobiliserId: beneficiaryForm.mobiliserName.id ? [beneficiaryForm.mobiliserName.id] : [],
                isPvtgClassified: beneficiaryForm.caste.value !== 'ST' ? null : beneficiaryForm.pvtg.value === 'Yes' ? true : false,
                enrollForSms: beneficiaryForm.sms.value,
                effectiveFromDt: null,
                wardId: beneficiaryForm.ward.id,
                villageId: beneficiaryForm.village.id,
                isTempReg:false,
                facilityId: facilityId,
                imageData: null,
                url: null,
                filePath: null,
                description: '',
                parentUserId: userId,
                parentUserTypeId: null,
                parentRoleId: null,
                IsSharedMobileNumber:beneficiary?.beneficiaryAlreadyInRCH,
                consentTemplateDetails:beneficiary?.consentLanguageID?  beneficiary?.consentLanguageID.map((item:any) => ({ consent_template_id: item?.consent_template_id })): null,
                processChannel: 'web',
                regProcessType: "reg_through_healtprovider",
                isFaceAuthenticated: beneficiary.beneficiaryRedgeOption == 'Face_Authentication' || false
            }
            try {
                const encodedNumber = encodeWithKeyAndShift(JSON.stringify({ abhaId: data[0]?.abhaId.replace(/-/g, "") }));
                  const abhaResponse = await postDataJSON<any>(`${endpoints.checkAbhaIdExist}`, { data: encodedNumber });
                  const decodedResponse = JSON.parse(decodeWithKeyAndShift(abhaResponse.data));
                  const abhaRes = decodedResponse[0];
                  const abhaFlag = abhaRes.check_abha_id_exists;
                  if(!abhaFlag){
                    const encodedPayload = encodeWithKeyAndShift(JSON.stringify(payload))
                    const response = await postDataJSON<any>(`${endpoints.createBeneficiary}`, {data:encodedPayload});

                    if(response.data && response.data.data[0]?.benf_id){
                        if (Files) {
                            if(Files instanceof FormData) {
                              Files.append("imageType", "beneficiary_profile");
                              Files.append("objectId", response.data.data[0]?.benf_id);
                             }
                            const responses = await axios.post(`${endpoints.beneficiaryImageUpload}`,Files, Auth.loggedInWithMultipart())
              
                          }
                        
                        navigate("/beneficiaries");
                        toast.success(benef_const.beneficiaryCreatedMessage, {
                            position: "top-center"
                        })
                        dispatch(setBeneficiaryRedgOption(''));
                        dispatch(setBeneficiaryAuthType(''));
                        dispatch(setAbhaAddress(''));
                        dispatch(setTxnIdForAbhaAddress(''));
                        handleDispatch();
                    }
                    else{
                        toast.error(benef_const.somethingWentWrong, {
                            position: "top-center"
                        })
                        
                    }
                  }
                  else{
                    toast.error(benef_const.abhaLinkedErrorMessage, {
                        position: "top-center"
                    })
                    navigate("/beneficiaries");
                    dispatch(updateForm("file", null));
                    dispatch(setBeneficiaryData([]));
                    dispatch(setBeneficiaryAbha(''));
                    dispatch(setTsnID(''));
                    dispatch(setBeneficiaryMobileNumber(''))
                    dispatch(setAadhar(''))
                }
            }
            catch(error:any){
                errorLogger(error?.response?.data||error?.response||error)
            }
        }
        
    }

    const handleDispatch = () => {
        dispatch(updateForm("file", null));
        dispatch(setBeneficiaryData([]));
        dispatch(setBeneficiaryAbha(''));
        dispatch(setTsnID(''));
        dispatch(setBeneficiaryMobileNumber(''));
        dispatch(setAadhar(''));
    }

    return (
        <div className="app-view-wrapper">
            <header className="view-header">
                <div className="logo-wrapper">
                    <NationalEmblem className="logo" />
                    <div className="name-wrapper">
                        <div className="name-wrapper-title">
                            JANANI
                        </div>
                        <div className="name-wrapper-subtext">
                            Journey of Antenatal, Natal and Neonatal Integrated Care
                        </div>
                        <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
                    </div>
                </div>
                <div className="view-route">
                    <BreadcrumbComponent
                        breadcrumbItemName={[
                            { value: 'Service Provider', label: 'Service Provider' },
                            { value: 'Beneficiary Registration', label: 'Beneficiary Registration' },
                        ]}
                    />
                </div>
            </header>
            <main className="view-content">
                <div className="view-profile-buttons">
                    <div className="view-profile">
                        <CommonHamburgar>
                            <LeftNavBar
                                navItems={['User Details']}
                                currentTab={'User Details'}
                                handleNavClick={() => { }}
                            />
                        </CommonHamburgar>
                        <Link to={'/beneficiaries'}>
                            <Button
                                onClick={() => handleDispatch()}
                                disabled={false}
                                id=""
                                buttonName={''}
                                colorType={'verticalbackbutton'}
                                icon={<BackArrowsvg />}
                                iconPosition={'left'}
                            />
                        </Link>
                        {
                            imageUrl !== '' ? <img
                                className="profile-picture"
                                src={imageUrl}
                                alt='Profile Image'
                            /> :
                                aadharImageUrl !== '' ? <img
                                    className="profile-picture"
                                    src={aadharImageUrl}
                                    alt='Profile Image'
                                /> : <img
                                    className="profile-picture"
                                    src={profilePic}
                                    alt='Profile Image'
                                />
                        }
                        <div style={{ display: "flex", flexDirection: "column", fontSize: "13px" }}>
                            <div className="name">{`${beneficiaryForm.name.value}`}</div>
                            <div style={{ display: "flex", flexDirection: "row", gap: "5px", fontSize: "13px" }}>
                                <div>
                                    {beneficiaryForm.gender.value === 'F' ? <WomanIcon /> : <ManIcon />}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                                    <Button
                                        onClick={() => handleUploadClick('local')}
                                        disabled={false}
                                        id="add-profile-picture"
                                        buttonName={imageUrl !== '' ? 'Change Profile Picture' : "+ Add Profile Picture"}
                                        colorType={'primary'}
                                        iconPosition={'left'}
                                    />
                                    <span className='tooltip-profile-pic'><CustomTooltip text={'File size must be less than or equal to 1MB and Only JPG, JPEG and PNG images are allowed'} /></span>
                                </div>

                                {imageError.length > 0 && <InfoBar
                                    variant="danger"
                                    message={imageError}
                                    className="input_field_class profile-pic-error"
                                />}
                            </div>
                            <input
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                onChange={handleFileChange}
                                className="profile-picture-hidden-input"
                                ref={inputRef}
                            />
                        </div>
                        {imageUrl !== '' && <Button
                            onClick={() => {
                                setImageUrl('')
                                setAadharImageUrl('')
                                dispatch(updateForm("file", null));
                            }}
                            disabled={false}
                            id="delete-profile-picture"
                            buttonName={'Delete'}
                            colorType={'save'}
                        />}

                    </div>
                </div>
                <div className="content">
                    <LeftNavBar
                        navItems={['User Details']}
                        currentTab={'User Details'}
                        handleNavClick={() => { }}
                    />
                    <div className="tab-content">
                        <div className="beneficiary_create">
                            <div className="create_beneficiary">

                                <BadgesComponent
                                    className="over-badge"
                                    badgeName="User Details"
                                    variant="primary-1"
                                    badgeType="case5"
                                />
                                <div className="overview-details-update">
                                    <div className="create_beneficiary_page">
                                        <form className="create_container_page">
                                            <CommonFormFields
                                                formData={beneficiaryFormData}
                                                formState={beneficiaryForm}
                                                handleFormChange={handleChange}
                                            />
                                        </form>
                                    </div>
                                </div>
                                {<div className="cancel-edit">
                                    {<Button
                                        onClick={() => {
                                            navigate("/beneficiaries");
                                            handleDispatch();
                                        }}
                                        disabled={false}
                                        id="cancel"
                                        buttonName={'Cancel'}
                                        colorType={'save'}
                                        icon={''}
                                        iconPosition={'right'}

                                    />}
                                    <Button
                                        onClick={handleSubmit}
                                        disabled={false}
                                        id={''}
                                        buttonName={'Submit'}
                                        colorType={'primary'}
                                        iconPosition={'right'}
                                    />
                                </div>}
                            </div>

                        </div>
                    </div>
                </div>
            </main>
        </div>

    );
};
export default CreateBeneficiary;
